<template>
  <div>
    <router-link v-if="button.type == 'router'" :to="button.path" type="button" :class="`btn ${btnClass}`">
      {{ button.name }}
    </router-link>
    <button v-else type="button" :class="`btn ${btnClass}`" @click="handleClick" >
      {{ button.name }}
    </button>
  </div>
</template>

<script>


export default {
  props: {
    button: {
      type: Object,
      required: false,
      default: {
        name: "Add New",
        type: "button",
        path: null
      }
    },

    handleClick: {
      type: Function,
      required: false
    },
    
    btnClass: {
      type: String,
      required: false,
      default: "btn-primary btn-rounded"
    }
  }
}


</script>
